import * as React from "react";
import {inject, observer} from "mobx-react";
import urllite from "urllite";
import ReactModal from 'react-modal';

@inject("store")
@observer
export class Rte extends React.Component { // icom rich text editor
    // model props
    constructor(props) {
        super(props);
        this.navigate = this.navigate.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.getCssText = this.getCssText.bind(this);
        this.updateCssText = this.updateCssText.bind(this);
        
        this.state = {
            showModal: false
        };

        this.readMoreKey = React.createRef();
        this.closeKey = React.createRef();
    }

    handleOpenModal () {
        this.setState({ showModal: true });
    }

    handleCloseModal () {
        this.setState({ showModal: false });
    }

    navigate(e) {
        const { navigation } = this.props.store;
        //const history = navigationStore.history;

        //const history = this.props.history;

        // Ignore canceled events, modified clicks, and right clicks.
        if (e.defaultPrevented) {
            return;
        }

        if (e.metaKey || e.ctrlKey || e.shiftKey) {
            return;
        }

        if (e.button !== 0) {
            return;
        }

        // Get the <a> element.
        var el = e.target;
        while (el && el.nodeName !== 'A') {
            el = el.parentNode;
        }

        // Ignore clicks from non-a elements.
        if (!el) {
            return;
        }

        // Ignore the click if the element has a target.
        if (el.target && el.target !== '_self') {
            return;
        }

        // Ignore the click if it's a download link. (We use this method of
        // detecting the presence of the attribute for old IE versions.)
        if (el.attributes.download) {
            return;
        }


        //console.debug("NAVIGATE!:", el);
        // Ignore hash (used often instead of javascript:void(0) in strict CSP envs)
        const href = el.getAttribute('href');
        if (href && href.length > 0 && href[0] === '#') { // && !(this.props.environment instanceof HashEnvironment)) {
            return;
        }

        var url = urllite(el.href);
        var windowURL = urllite(window.location.href);

        // Ignore links that don't share a protocol and host with ours.
        if (url.protocol !== windowURL.protocol || url.host !== windowURL.host) {
            return;
        }

        // Ignore 'rel="external"' links.
        if (el.rel && /(?:^|\s+)external(?:\s+|$)/.test(el.rel)) {
            return;
        }

        // Prevent :focus from sticking; preventDefault() stops blur in some browsers
        el.blur();
        e.preventDefault();


        //console.debug("NAVIGATE", url.protocol, windowURL.protocol);
        //history.push(url);
        navigation.navigateToSiteUrl(null, url.pathname, null, null, url.search);
    }
    getCssText(html) {
        let result = "";
        let currentValue = "";

        if (typeof html !== "string") {
            if (html.length < 1) {
                return ;
            }

            const currentCultureValue = html.find(item => item.culture === this.props.store.navigation.CultureCode);

            if (currentCultureValue) {
                currentValue = currentCultureValue.value;
            } else if (html.length > 0) {
                currentValue = html[0].value;
            } else {
                return ;
            }
        } else {
            currentValue = html;
        }
        
        if (currentValue.indexOf("read-more-container") > 0) {
            let div = document.createElement('div');
            div.innerHTML = currentValue;
            let readMoreContainer = div.getElementsByClassName("read-more-container")[0];
            if (readMoreContainer) {
                result = readMoreContainer.style.cssText;
            }
        }
        return result;
    }
    
    componentDidMount() {
        this.updateCssText();
    }

    componentDidUpdate() {
        this.updateCssText();
    }
    
    updateCssText() {
        const { model } = this.props;
        if (!model || !model.value) return; // Early out..

        const value = model.value.value || model.value;
        const css = this.getCssText(value);
        if (this.readMoreKey.current) {
            this.readMoreKey.current.setAttribute('style', css);
        }
        if (this.closeKey.current) {
            this.closeKey.current.setAttribute('style', css);
        }
    }

    render() {
        const { model } = this.props;
        if (!model.value) return (null); // Early out..

        const value = model.value.value || model.value;
        let currentValue = "";

        if (typeof value !== "string") {
            if (value.length < 1) {
                return (null);
            }

            const currentCultureValue = value.find(item => item.culture === this.props.store.navigation.CultureCode);

            if (currentCultureValue) {
                currentValue = currentCultureValue.value;
            } else if (value.length > 0) {
                currentValue = value[0].value;
            } else {
                return (null);
            }
        } else {
            currentValue = value;
        }

        let allValue = currentValue + "";
        let hasReadMore = false;
        let buttonClasses = "";
        let cssStyle = "";
        if (allValue.indexOf("read-more-container") > 0) {
            let div = document.createElement('div');
            div.innerHTML = allValue;
            let readMoreContainer = div.getElementsByClassName("read-more-container")[0];
            let classIndex = readMoreContainer.outerHTML.indexOf("read-more-container");
            
            let index = allValue.indexOf("read-more-container") - classIndex;

            if (index > -1) {
                currentValue = allValue.substring(0, index);
                let classes = readMoreContainer.classList;
                cssStyle = readMoreContainer.style.cssText;
                classes.remove("read-more-container");
                let arr = [];
                if (classes.length > 0) {
                    // iterate backwards ensuring that length is an UInt32
                    for (let i = classes.length >>> 0; i--;) {
                        arr[i] = classes[i];
                    }

                    buttonClasses = arr.join(' ') + " " + buttonClasses;
                }
                hasReadMore = true

                readMoreContainer.parentNode.removeChild(readMoreContainer);
                allValue = div.innerHTML + "";
            }
        }
        
        return (
            <div onClick={(e) => this.navigate(e)}
                 className="rte-padding" >
                <div dangerouslySetInnerHTML={{ __html: currentValue  }} />
                {hasReadMore && <React.Fragment><p ref={this.readMoreKey} className={buttonClasses}><a className={"block-button read-more-color"} href={"#"} onClick={this.handleOpenModal}>{this.props.store.navigation.dictionary.ReadMore || "read more"}</a></p>
                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel=""
                    onRequestClose={this.handleCloseModal}
                    className={"text-modal"}
                    overlayClassName={"overlay-text-modal"}
                    ariaHideApp={false}
                    contentRef={node => this.updateCssText()}>
                    <div dangerouslySetInnerHTML={{ __html: allValue }} />
                    <p ref={this.closeKey} className={buttonClasses} ><a className={"block-button read-more-color"} href={"#"} onClick={this.handleCloseModal}>{this.props.store.navigation.dictionary.CloseReadMore || "Close"}</a></p>
                </ReactModal></React.Fragment>
                }
            </div>
        );
    }
}

@inject("store")
@observer
export class RichTextFramed extends React.Component {
    // model props
    constructor(props) {
        super(props);
        this.navigate = this.navigate.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.state = {
            showModal: false
        };
    }

    handleOpenModal () {
        this.setState({ showModal: true });
    }

    handleCloseModal () {
        this.setState({ showModal: false });
    }
    
    navigate(e) {
        const { navigation } = this.props.store;
        //const history = navigationStore.history;

        //const history = this.props.history;

        // Ignore canceled events, modified clicks, and right clicks.
        if (e.defaultPrevented) {
            return;
        }

        if (e.metaKey || e.ctrlKey || e.shiftKey) {
            return;
        }

        if (e.button !== 0) {
            return;
        }

        // Get the <a> element.
        var el = e.target;
        while (el && el.nodeName !== 'A') {
            el = el.parentNode;
        }

        // Ignore clicks from non-a elements.
        if (!el) {
            return;
        }

        // Ignore the click if the element has a target.
        if (el.target && el.target !== '_self') {
            return;
        }

        // Ignore the click if it's a download link. (We use this method of
        // detecting the presence of the attribute for old IE versions.)
        if (el.attributes.download) {
            return;
        }


        //console.debug("NAVIGATE!:", el);
        // Ignore hash (used often instead of javascript:void(0) in strict CSP envs)
        const href = el.getAttribute('href');
        if (href && href.length > 0 && href[0] === '#') { // && !(this.props.environment instanceof HashEnvironment)) {
            return;
        }

        var url = urllite(el.href);
        var windowURL = urllite(window.location.href);

        // Ignore links that don't share a protocol and host with ours.
        if (url.protocol !== windowURL.protocol || url.host !== windowURL.host) {
            return;
        }

        // Ignore 'rel="external"' links.
        if (el.rel && /(?:^|\s+)external(?:\s+|$)/.test(el.rel)) {
            return;
        }

        // Prevent :focus from sticking; preventDefault() stops blur in some browsers
        el.blur();
        e.preventDefault();


        //console.debug("NAVIGATE", url.protocol, windowURL.protocol);
        //history.push(url);
        navigation.navigateToSiteUrl(null, url.pathname, null, null, url.search);
    }

    hexToRgbA(hex) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.56)';
        }
        return "";
        //throw new Error('Bad Hex');
    }

    render() {
        const serverRender = typeof window === 'undefined';
        //!serverRender && console.debug("RichTextFramed", this.props);
        const { model } = this.props;
        if (!model.value) return (null); // Early out..

        let currentValue = model.value.value;
        
        let allValue = currentValue + "";
        let hasReadMore = false;
        let buttonClasses = "";
        if (allValue.indexOf("read-more-container") > 0) {
            let index = allValue.indexOf('<p class="read-more-container');

            if (index > -1) {
                currentValue = allValue.substring(0, index);
                let div = document.createElement('div');
                div.innerHTML = allValue;
                let readMoreContainer = div.getElementsByClassName("read-more-container")[0];
                let classes = readMoreContainer.classList;
                classes.remove("read-more-container");
                let arr = [];
                if (classes.length > 0) {
                    // iterate backwards ensuring that length is an UInt32
                    for (let i = classes.length >>> 0; i--;) {
                        arr[i] = classes[i];
                    }

                    buttonClasses = arr.join(' ') + " " + buttonClasses;
                }
                hasReadMore = true
            }
        }
        
        return (
            <div onClick={(e) => this.navigate(e)}
                 className="rte-padding rte-framed" style={{ backgroundColor: this.hexToRgbA(model.value.background) }} >
                <div dangerouslySetInnerHTML={{ __html: currentValue }} />
                {hasReadMore && <React.Fragment><p className={buttonClasses}><a className={"block-button"} href={"#"} onClick={this.handleOpenModal}>{this.props.store.navigation.dictionary.readMore || "read more"}</a></p>
                    <ReactModal
                        isOpen={this.state.showModal}
                        contentLabel=""
                        onRequestClose={this.handleCloseModal}
                        className={"text-modal"}
                        overlayClassName={"overlay-text-modal"}
                    >
                        <div dangerouslySetInnerHTML={{ __html: allValue }} />
                        <p className={buttonClasses}><a className={"block-button"} href={"#"} onClick={this.handleCloseModal}>{this.props.store.navigation.dictionary.closeReadMore || "Close"}</a></p>
                    </ReactModal></React.Fragment>
                }
            </div>
        );
    }
}
